<template>
  <div v-if="loading" class="loader">
    <!-- <b-spinner
      variant="primary"
      type="grow"
      :label="`${this.$t('reports.loadingLabel')}...`"
    ></b-spinner> -->
    <b-table :items="[0, 1, 2, 3]" :fields="fieldsGeneral">
      <template #cell(id)>
        <idx-skeleton height="15" radius="10"></idx-skeleton>
      </template>

      <template #cell(score)>
        <idx-skeleton height="15" radius="10"></idx-skeleton>
      </template>

      <template #cell(qtd)>
        <idx-skeleton height="15" radius="10"></idx-skeleton>
      </template>
    </b-table>
  </div>
  <div v-else id="categoriesReport" class="px-2 py-2 wrapper-categories">
    <div style="font-size:12px;" class="main mb-2">
      <div class="filters">
        <b-button-group>
          <b-button
            class="buttons-filters"
            @click="profile = 'all'"
            v-bind:class="{
              active: profile === 'all',
            }"
            >Todos</b-button
          >
          <b-button
            class="buttons-filters"
            @click="profile = 'promoters'"
            v-bind:class="{
              active: profile === 'promoters',
            }"
            >Promotores</b-button
          >
          <b-button
            class="buttons-filters"
            @click="profile = 'neutral'"
            v-bind:class="{
              active: profile === 'neutral',
            }"
            >Neutros</b-button
          >
          <b-button
            class="buttons-filters"
            @click="profile = 'detractors'"
            v-bind:class="{
              active: profile === 'detractors',
            }"
            >Detratores</b-button
          >
        </b-button-group>
      </div>
    </div>

    <div
      v-if="categoriesAnalysis"
      class="mb-4 mt-2"
      style="display: flex; float: left; font-size: 12px;"
    >
      <b-form-radio-group
        id="type-radio-group"
        name="radio-calculation"
        :value="categoryOption"
        v-model="categoryOption"
      >
        <b-form-radio style="font-size: 12px;" name="frequency-radio" value="true">
          {{ this.$t('reports.categories.frequencyOption') }}
        </b-form-radio>
        <b-form-radio style="font-size: 12px;" name="answer-radio" value="false">
          {{ this.$t('reports.categories.normalOption') }}
        </b-form-radio>
      </b-form-radio-group>

      <font-awesome-icon
        id="category-option-info"
        :icon="['fas', 'info-circle']"
        style="font-size: 15px; color: #c1c1c1;"
      />
      <b-popover
        target="category-option-info"
        triggers="hover"
        placement="bottom"
      >
        <b>Categoria (base frequência)</b> - Cálculo: Categoria / Total de
        categorias.<br />
        <br />
        <b>Categoria (base respostas)</b> - Cálculo: Categoria / Total de
        respostas.
      </b-popover>
    </div>

    <div v-if="profile === 'all'">
      <b-table
        v-if="generalItems.qtd > 0"
        :items="generalItems.items"
        :fields="fieldsGeneral"
        style="font-size: 12px;"
      >
        <template #cell(show_details)="row">
          <b-form-checkbox
            v-if="row.item.subCategories.length > 0"
            v-model="row.detailsShowing"
            @change="row.toggleDetails"
          >
          </b-form-checkbox>
        </template>
        <template #cell(id)="row">
           {{ getCategoryName(row.item.id) }}
        </template>
        <template #cell(progress)="row">
          <div class="mt-2" style="width: 100%;">
            <b-progress
              variant="info"
              :value="Math.round((row.item.qtd / generalItems.qtd) * 100)"
              :max="100"
            ></b-progress>
          </div>
        </template>
        <template #cell(score)="row">
          <div class="text-center">
            {{ Math.round((row.item.qtd / generalItems.qtd) * 100) }}%
          </div>
        </template>
        <template #row-details="row">
          <div class="col-12 subHeader">
            {{ $t('reports.categories.subcategories') }}:
          </div>
          <div v-for="(sub, index) in row.item.subCategories" :key="index.id">
            <b-row class="subLine">
              <div class="questionSub text-right">
                {{ getSubCategoryName(sub.id) }}
              </div>
              <div class="progressSub">
                <b-progress
                  variant="info"
                  :value="Math.round((sub.qtd / row.item.qtd) * 100)"
                  :max="100"
                ></b-progress>
              </div>
              <div v-if="categoryOption" class="catColumnSub">
                {{ Math.round((sub.qtd / generalItems.qtd) * 100) }}% /
                {{ sub.qtd }}
              </div>
              <div v-else class="catColumnSub">
                {{ Math.round((sub.qtd / row.item.qtd) * 100) }}% /
                {{ sub.qtd }}
              </div>
            </b-row>
          </div>
        </template>
      </b-table>
      <div v-if="generalItems.qtd > 0" class="col-12 text-right mb-3 pr25">
        {{ categoryLabel }}:
        {{ generalItems.qtd }}
      </div>
    </div>

    <div
      class="text-center"
      style="margin-top: 75px;"
      v-if="generalItems.qtd === 0 && profile === 'all'"
    >
      Sem dados para mostrar
    </div>

    <div v-if="profile === 'promoters'">
      <b-table
        v-if="promoters.qtd > 0"
        :items="promoters.items"
        :fields="fieldsPromoter"
        style="font-size: 12px;"
      >
        <template #cell(show_details)="row">
          <b-form-checkbox
            v-if="row.item.subCategories.length > 0"
            v-model="row.detailsShowing"
            @change="row.toggleDetails"
          >
          </b-form-checkbox>
        </template>
        <template #cell(id)="row">
          {{ getCategoryName(row.item.id) }}
        </template>
        <template #cell(progress)="row">
          <div class="mt-2" style="width: 100%;">
            <b-progress
              :value="Math.round((row.item.qtd / promoters.qtd) * 100)"
              :max="100"
            ></b-progress>
          </div>
        </template>
        <template #cell(score)="row">
          <div class="text-center">
            {{ Math.round((row.item.qtd / promoters.qtd) * 100) }}%
          </div>
        </template>
        <template #row-details="row">
          <div class="col-12 subHeader">
            {{ $t('reports.categories.subcategories') }}:
          </div>
          <div v-for="(sub, index) in row.item.subCategories" :key="index.id">
            <b-row class="subLine">
              <div class="questionSub text-right">
                {{ getSubCategoryName(sub.id) }}
              </div>
              <div class="progressSub">
                <b-progress
                  :value="Math.round((sub.qtd / row.item.qtd) * 100)"
                  :max="100"
                ></b-progress>
              </div>
              <div v-if="categoryOption" class="catColumnSub">
                {{ Math.round((sub.qtd / promoters.qtd) * 100) }}% /
                {{ sub.qtd }}
              </div>
              <div v-else class="catColumnSub">
                {{ Math.round((sub.qtd / row.item.qtd) * 100) }}% /
                {{ sub.qtd }}
              </div>
            </b-row>
          </div>
        </template>
      </b-table>
      <div v-if="promoters.qtd > 0" class="col-12 text-right mb-3 pr25">
        {{ categoryLabel }}:
        {{ promoters.qtd }}
      </div>
    </div>

    <div
      class="text-center"
      style="margin-top: 75px;"
      v-if="promoters.qtd === 0 && profile === 'promoters'"
    >
      Sem dados para mostrar
    </div>

    <div v-if="profile === 'neutral'">
      <b-table
        v-if="passives.qtd > 0"
        :items="passives.items"
        :fields="fieldsPassive"
        style="font-size: 12px;"
      >
        <template #cell(show_details)="row">
         <b-form-checkbox
            v-if="row.item.subCategories.length > 0"
            v-model="row.detailsShowing"
            @change="row.toggleDetails"
          >
          </b-form-checkbox>
        </template>
        <template #cell(id)="row">
          {{ getCategoryName(row.item.id) }}
        </template>
        <template #cell(progress)="row">
          <div class="mt-2" style="width: 100%;">
            <b-progress
              variant="warning"
              :value="Math.round((row.item.qtd / passives.qtd) * 100)"
              :max="100"
            ></b-progress>
          </div>
        </template>
        <template #cell(score)="row">
          <div class="text-center">
            {{ Math.round((row.item.qtd / passives.qtd) * 100) }}%
          </div>
        </template>
        <template #row-details="row">
          <div class="col-12 subHeader">
            {{ $t('reports.categories.subcategories') }}:
          </div>
          <div v-for="(sub, index) in row.item.subCategories" :key="index.id">
            <b-row class="subLine">
              <div class="questionSub text-right">
                {{ getSubCategoryName(sub.id) }}
              </div>
              <div class="progressSub">
                <b-progress
                  variant="warning"
                  :value="Math.round((sub.qtd / row.item.qtd) * 100)"
                  :max="100"
                ></b-progress>
              </div>
              <div v-if="categoryOption" class="catColumnSub">
                {{ Math.round((sub.qtd / passives.qtd) * 100) }}% /
                {{ sub.qtd }}
              </div>
              <div v-else class="catColumnSub">
                {{ Math.round((sub.qtd / row.item.qtd) * 100) }}% /
                {{ sub.qtd }}
              </div>
            </b-row>
          </div>
        </template>
      </b-table>
      <div v-if="passives.qtd > 0" class="col-12 text-right mb-3 pr25">
        {{ categoryLabel }}:
        {{ passives.qtd }}
      </div>
    </div>

    <div
      class="text-center"
      style="margin-top: 75px;"
      v-if="passives.qtd === 0 && profile === 'neutral'"
    >
      Sem dados para mostrar
    </div>

    <div v-if="profile === 'detractors'">
      <b-table
        v-if="detractors.qtd > 0"
        :items="detractors.items"
        :fields="fieldsDetractor"
        style="font-size: 12px;"
      >
        <template #cell(show_details)="row">
          <b-form-checkbox
            v-if="row.item.subCategories.length > 0"
            v-model="row.detailsShowing"
            @change="row.toggleDetails"
          >
          </b-form-checkbox>
        </template>
        <template #cell(id)="row">
          {{ getCategoryName(row.item.id) }}
        </template>
        <template #cell(progress)="row">
          <div class="mt-2" style="width: 100%;">
            <b-progress
              variant="danger"
              :value="Math.round((row.item.qtd / detractors.qtd) * 100)"
              :max="100"
            ></b-progress>
          </div>
        </template>
        <template #cell(score)="row">
          <div class="text-center">
            {{ Math.round((row.item.qtd / detractors.qtd) * 100) }}%
          </div>
        </template>
        <template #row-details="row">
          <div class="col-12 subHeader">
            {{ $t('reports.categories.subcategories') }}:
          </div>
          <div v-for="(sub, index) in row.item.subCategories" :key="index.id">
            <b-row class="subLine">
              <div class="questionSub text-right">
                {{ getSubCategoryName(sub.id) }}
              </div>
              <div class="progressSub">
                <b-progress
                  variant="danger"
                  :value="Math.round((sub.qtd / row.item.qtd) * 100)"
                  :max="100"
                ></b-progress>
              </div>
              <div v-if="categoryOption" class="catColumnSub">
                {{ Math.round((sub.qtd / detractors.qtd) * 100) }}% /
                {{ sub.qtd }}
              </div>
              <div v-else class="catColumnSub">
                {{ Math.round((sub.qtd / row.item.qtd) * 100) }}% /
                {{ sub.qtd }}
              </div>
            </b-row>
          </div>
        </template>
      </b-table>
      <div v-if="detractors.qtd > 0" class="col-12 text-right mb-3 pr25">
        {{ categoryLabel }}:
        {{ detractors.qtd }}
      </div>
    </div>

    <div
      class="text-center"
      style="margin-top: 75px;"
      v-if="detractors.qtd === 0 && profile === 'detractors'"
    >
      Sem dados para mostrar
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import idxSkeleton from '@/components/molecules/idx-skeleton';
import api from '../../../../../../services/api';
import eventBus from '../../../../../../eventBus';
export default {
  name: 'CategoriesPanel',
  props: ['dataGraph'],
  components: {
    idxSkeleton,
  },
  data: () => ({
    userAuth: null,
    visible: true,
    total: 0,
    page: 1,
    limit: 10,
    generalItems: { qtd: 0 },
    promoters: {},
    passives: {},
    detractors: {},
    categories: [],
    subCategories: [],
    subcategory_generalItems: {},
    subcategory_promoters: {},
    subcategory_passives: {},
    subcategory_detractors: {},
    fieldsGeneral: [],
    fieldsPromoter: [],
    fieldsPassive: [],
    fieldsDetractor: [],
    promoterLabel: '',
    neutralLabel: '',
    detractorLabel: '',
    categoriesAnalysis: false,
    categoryOption: false,
    categoryLabel: '',
    loading: false,
    profile: 'all',
  }),
  watch: {
    actionGroupData: function watchActionGroupData() {
      this.setData();
    },
    myMetric: function watchMyMetric() {
      this.setData();
    },
    myActionId: function watchMyActionId() {
      this.setData();
    },
    myIh1: function watchMyIh1() {
      this.setData();
    },
    myIh2: function watchMyIh2() {
      this.setData();
    },
    calendarDates: function watchDates() {
      this.setData();
    },
    'indicatorData.value': function watchindicatorData() {
      this.setData();
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      await this.setData();
    },
    categoryOption: function watchCategoryOption() {
      this.setData();
    },
  },
  computed: {
    ...mapState('actions', ['myActionId', 'actionGroupData']),
    ...mapState('charts', ['reportCategories']),
    ...mapState('branches', ['myIh1', 'myIh2']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('companies', ['myMetric']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
  },
  methods: {
    ...mapActions('charts', ['getReportCategories']),
    ...mapActions('calendar', ['setDefaultDates']),
    changeCategoryOption() {
      this.categoryOption = !this.categoryOption;
    },
    async setData() {
      this.loading = true;
      // await this.getReportCategories({
      //   token: this.userAuth.token,
      //   companyId: this.userAuth.companyId,
      //   actionId: this.dataGraph.actionId ? this.dataGraph.actionId._id : null,
      //   page: this.page,
      //   limit: this.limit,
      //   startDate: this.calendarDates.start ? this.calendarDates.start : null,
      //   endDate: this.calendarDates.end ? this.calendarDates.end : null,
      //   ih1: this.dataGraph.ih1 ? this.dataGraph.ih1._id : null,
      //   groupId: this.dataGraph.actionGroupId
      //     ? this.dataGraph.actionGroupId._id
      //     : null,
      //   indicator: this.dataGraph.indicator ? this.dataGraph.indicator : null,
      //   indicatorValue: this.dataGraph.valueIndicator,
      //   metric: this.dataGraph.metric,
      //   period: this.dataGraph.period,
      //   frequencyOption: this.categoryOption,
      // });
      const response = await api.get('/reports/get-report-categories-panel', {
          headers: {
            'x-access-token': this.userAuth.token,
          },
          params: {
            companyId: this.userAuth.companyId,
            actionId: this.dataGraph.actionId ? this.dataGraph.actionId._id : null,
            page: this.page,
            limit: this.limit,
            startDate: this.calendarDates.start ? this.calendarDates.start : null,
            endDate: this.calendarDates.end ? this.calendarDates.end : null,
            ih1:  this.dataGraph.ih1 && this.dataGraph.ih1.length > 0 ? this.dataGraph.ih1.map((item) => item._id): null,
            groupId: this.dataGraph.actionGroupId
              ? this.dataGraph.actionGroupId._id
              : null,
            indicator: this.dataGraph.indicator ? this.dataGraph.indicator : null,
            indicatorValue: this.dataGraph.valueIndicator,
            metric: this.dataGraph.metric,
            period: this.dataGraph.period,
            frequencyOption: this.categoryOption,
            _id: this.dataGraph._id,
          },
      });
      this.categories = response.data.result.categories;
      this.subCategories = response.data.result.subCategories;
      this.generalItems = response.data.generalItems;
      this.promoters = response.data.promoters;
      this.passives = response.data.passives;
      this.detractors = response.data.detractors;
      // subCategories
      this.subcategory_generalItems = response.data.subcategory_generalItems;
      this.subcategory_promoters = response.data.subcategory_promoters;
      this.subcategory_passives = response.data.subcategory_passives;
      this.subcategory_detractors = response.data.subcategory_detractors;
      // change lists for adding subcategories array
      const generalItens = await this.fixList(
        this.generalItems.items,
        'general',
      );
      const promoterItens = await this.fixList(
        this.promoters.items,
        'promoter',
      );
      const passiveItens = await this.fixList(this.passives.items, 'passive');
      const detractorItens = await this.fixList(
        this.detractors.items,
        'detractor',
      );
      this.generalItems = {
        qtd: this.generalItems.qtd,
        items: generalItens,
      };
      this.promoters = {
        qtd: this.promoters.qtd,
        items: promoterItens,
      };
      this.passives = {
        qtd: this.passives.qtd,
        items: passiveItens,
      };
      this.detractors = {
        qtd: this.detractors.qtd,
        items: detractorItens,
      };
      if (this.categoryOption) {
        this.categoryLabel = this.$t('reports.categories.totalCategories');
      } else {
        this.categoryLabel = this.$t('reports.categories.totalCategorized');
      }
      this.loading = false;
    },
    fixList(list, type) {
      const newList = [];
      // eslint-disable-next-line
      for (const prop in list) {
        const hasSubcategories = this.hasSubCategory(prop, type);
        let subCategories = [];
        if (hasSubcategories) {
          subCategories = this.buildSubcategoriesList(prop, type);
        }
        const obj = {
          id: prop,
          qtd: list[prop],
          hasSubcategories,
          subCategories,
        };
        newList.push(obj);
      }
      return newList;
    },
    async getCustomCategoriesAnalysis() {
      try {
        const response = await api.get('/categories-analysis', {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        });
        this.categoriesAnalysis = response.data.customCategoriesAnalysis;
        if (this.categoriesAnalysis) {
          this.categoryOption = true;
        }
      } catch (error) {
        window.console.log(error);
      }
    },
    async getCategories() {
      try {
        const response = await api.get('/categories-panel', {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        });
        this.categories = response.data;
      } catch (error) {
        window.console.log(error);
      }
    },
    async getSubCategories() {
      try {
        const response = await api.get('/all-subcategories', {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        });
        this.subCategories = response.data;
      } catch (error) {
        window.console.log(error);
      }
    },
    getCategoryName(id) {
      for (let i = 0; i < this.categories.length; i += 1) {
        if (id === this.categories[i].categoryId) {
          return this.categories[i].name;
        }
      }
      return '';
    },
    getSubCategoryName(id) {
      for (let i = 0; i < this.subCategories.length; i += 1) {
        if (id === this.subCategories[i]._id) {
          return this.subCategories[i].name;
        }
      }
      return '';
    },
    hasSubCategory(item, type) {
      switch (type) {
        case 'general':
          if (
            this.subcategory_generalItems &&
            this.subcategory_generalItems.items
          ) {
            // eslint-disable-next-line
           for (let prop in this.subcategory_generalItems.items) {
              for (let j = 0; j < this.subCategories.length; j += 1) {
                if (
                  prop === this.subCategories[j]._id &&
                  this.subCategories[j].mainCategoryId === item
                ) {
                  return true;
                }
              }
            }
           }
          break;
        case 'promoter':
          if (this.subcategory_promoters && this.subcategory_promoters.items) {
            // eslint-disable-next-line
            for (let prop in this.subcategory_promoters.items) {
              for (let j = 0; j < this.subCategories.length; j += 1) {
                if (
                  prop === this.subCategories[j]._id &&
                  this.subCategories[j].mainCategoryId === item
                ) {
                  return true;
                }
              }
            }
          }
          break;
        case 'passive':
          if (this.subcategory_passives && this.subcategory_passives.items) {
            // eslint-disable-next-line
            for (let prop in this.subcategory_passives.items) {
              for (let j = 0; j < this.subCategories.length; j += 1) {
                if (
                  prop === this.subCategories[j]._id &&
                  this.subCategories[j].mainCategoryId === item
                ) {
                  return true;
                }
              }
            }
          }
          break;
        case 'detractor':
          if (
            this.subcategory_detractors &&
            this.subcategory_detractors.items
          ) {
            // eslint-disable-next-line
            for (let prop in this.subcategory_detractors.items) {
              for (let j = 0; j < this.subCategories.length; j += 1) {
                if (
                  prop === this.subCategories[j]._id &&
                  this.subCategories[j].mainCategoryId === item
                ) {
                  return true;
                }
              }
            }
          }
          break;
        default:
          break;
      }
      return false;
    },
    buildSubcategoriesList(item, type) {
      const subCategoriesList = [];
      switch (type) {
        case 'general':
          // eslint-disable-next-line
          for (let prop in this.subcategory_generalItems.items) {
            for (let j = 0; j < this.subCategories.length; j += 1) {
              if (
                prop === this.subCategories[j]._id &&
                this.subCategories[j].mainCategoryId === item
              ) {
                subCategoriesList.push({
                  id: prop,
                  qtd: this.subcategory_generalItems.items[prop],
                });
              }
            }
          }
          break;
        case 'promoter':
          // eslint-disable-next-line
          for (let prop in this.subcategory_promoters.items) {
            for (let j = 0; j < this.subCategories.length; j += 1) {
              if (
                prop === this.subCategories[j]._id &&
                this.subCategories[j].mainCategoryId === item
              ) {
                subCategoriesList.push({
                  id: prop,
                  qtd: this.subcategory_promoters.items[prop],
                });
              }
            }
          }
          break;
        case 'passive':
          // eslint-disable-next-line
          for (let prop in this.subcategory_passives.items) {
            for (let j = 0; j < this.subCategories.length; j += 1) {
              if (
                prop === this.subCategories[j]._id &&
                this.subCategories[j].mainCategoryId === item
              ) {
                subCategoriesList.push({
                  id: prop,
                  qtd: this.subcategory_passives.items[prop],
                });
              }
            }
          }
          break;
        case 'detractor':
          // eslint-disable-next-line
          for (let prop in this.subcategory_detractors.items) {
            for (let j = 0; j < this.subCategories.length; j += 1) {
              if (
                prop === this.subCategories[j]._id &&
                this.subCategories[j].mainCategoryId === item
              ) {
                subCategoriesList.push({
                  id: prop,
                  qtd: this.subcategory_detractors.items[prop],
                });
              }
            }
          }
          break;
        default:
          break;
      }
      return subCategoriesList;
    },
  },
  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    if (this.dataGraph.metric.indexOf('nps') !== -1) {
      this.promoterLabel = this.$t('reports.promoterLabel');
      this.neutralLabel = this.$t('reports.neutralLabel');
      this.detractorLabel = this.$t('reports.detractorLabel');
    } else {
      this.promoterLabel = '4-5';
      this.neutralLabel = '3';
      this.detractorLabel = '1-2';
    }
    this.fieldsGeneral = [
      {
        key: 'show_details',
        label: '',
        class: 'column2',
      },
      {
        key: 'id',
        label: this.$t('reports.categories.allCategories'),
        class: 'questionTh',
      },
      {
        key: 'progress',
        label: '',
        class: 'progressTh',
      },
      {
        key: 'score',
        label: this.$t('reports.categories.scorelabel'),
        class: 'catColumn',
      },
      {
        key: 'qtd',
        label: this.$t('reports.categories.totalLabel'),
        class: 'catColumn',
      },
    ];
    this.fieldsPromoter = [
      {
        key: 'show_details',
        label: '',
        class: 'column2',
      },
      {
        key: 'id',
        label: this.promoterLabel,
        class: 'questionTh',
      },
      {
        key: 'progress',
        label: '',
        class: 'progressTh',
      },
      {
        key: 'score',
        label: this.$t('reports.categories.scorelabel'),
        class: 'catColumn',
      },
      {
        key: 'qtd',
        label: this.$t('reports.categories.totalLabel'),
        class: 'catColumn',
      },
    ];
    this.fieldsPassive = [
      {
        key: 'show_details',
        label: '',
        class: 'column2',
      },
      {
        key: 'id',
        label: this.neutralLabel,
        class: 'questionTh',
      },
      {
        key: 'progress',
        label: '',
        class: 'progressTh',
      },
      {
        key: 'score',
        label: this.$t('reports.categories.scorelabel'),
        class: 'catColumn',
      },
      {
        key: 'qtd',
        label: this.$t('reports.categories.totalLabel'),
        class: 'catColumn',
      },
    ];
    this.fieldsDetractor = [
      {
        key: 'show_details',
        label: '',
        class: 'column2',
      },
      {
        key: 'id',
        label: this.detractorLabel,
        class: 'questionTh',
      },
      {
        key: 'progress',
        label: '',
        class: 'progressTh',
      },
      {
        key: 'score',
        label: this.$t('reports.categories.scorelabel'),
        class: 'catColumn',
      },
      {
        key: 'qtd',
        label: this.$t('reports.categories.totalLabel'),
        class: 'catColumn',
      },
    ];
  },
  async mounted() {
    await this.getCustomCategoriesAnalysis();
    // await this.getCategories();
    // await this.getSubCategories();
    await this.setData();
  },
};
</script>

<style scoped>
.filters {
  background: #f0f6fb;
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 20px;
  margin-top: 12px;
}
.buttons-filters {
  background: #f0f6fb;
  border-radius: 50rem;
  padding-left: 15px;
  padding-right: 15px;
  border: none;
  outline: none;
  font-size: 12px;
}
.buttons-filters.active {
  background: #fff !important;
  border-radius: 50rem !important;
  padding-left: 15px !important ;
  padding-right: 15px !important;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  font-weight: bold !important;
}
.main {
  display: flex;
  padding: 0;
  align-items: center;
  justify-content: center;
  width: 100%;
}
</style>

<style lang="scss">
.no-padding {
  padding: 0;
}
.table {
  margin: 0;
}
.wrapper-categories .table > thead > tr:nth-child(2) {
  display: none;
}
.wrapper-categories .btn .btn-light .collapsed {
  background-color: transparent;
}
.catColumn {
  width: 70px;
  text-align: center;
}
.progressTh {
  width: 20%;
}
.questionTh {
  width: 75%;
}
.column2 {
  width: 2%;
  min-width: 50px;
}
.questionSub {
  width: 30%;
  padding-right: 10px;
}
.progressSub {
  width: 10%;
}
.catColumnSub {
  font-weight: bold;
  padding: 0 10px;
}
.pr25 {
  padding-right: 25px;
}
.progressSub .progress {
  background-color: white;
  margin-top: 4px;
}
.subLine {
  background: #eee;
  padding: 5px;
  border: solid 1px white;
}
.subHeader {
  font-weight: bold;
  padding-left: 30%;
}
#categoriesReport input[type='checkbox'] + label::before {
  content: '\f0fe';
  font-family: FontAwesome;
  display: inline-block;
  padding-right: 5px;
  color: #4ce595;
  border: none;
  margin-top: -5px;
}
#categoriesReport input[type='checkbox']:checked + label::before {
  content: '\f146';
  margin-top: -5px;
  color: #4ce595 !important;
  background-color: white !important;
  z-index: 1;
}
#categoriesReport input {
  display: none;
}
.loader {
  width: 100%;
  height: 350px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.btn-category {
  color: white !important;
  background-color: #4ce595 !important;
  border: 1px solid #4ce595;
}
</style>


// WEBPACK FOOTER //
// src/components/molecules/highcharts/reports/categories/panels/categories.vue